import authRequest from '../authRequest'
import { handleError } from '../errorHandling'

const sendPatientMessage = async ({ uuid, body, subject = null, attachment = null, filename = null, sessionUuid = null }) => {
  try {
    const formData = new FormData()
    
    if (attachment) {
      // If filename is provided, create a File object from the blob
      if (filename) {
        const file = new File([attachment], filename, { type: attachment.type });
        formData.append('message[attachment]', file);
      } else {
        formData.append('message[attachment]', attachment);
      }
    }
    
    formData.append('message[body]', body)

    if (subject) {
      formData.append('message[subject]', subject)
    }

    if (sessionUuid) {
      formData.append('message[session_uuid]', sessionUuid)
    }

    const response = await authRequest(`/patients/${uuid}/send_message`, {
      method: 'POST',
      data: formData,
    })

    if (response.status !== 200) {
      throw new Error('Failed to send patient message')
    }

    return response.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export default sendPatientMessage 